import React, {Component} from 'react';
export default class Introduce extends Component{
    constructor(props) {
        super(props);
        this.state = {
            activeTabIdx: 0,
            tabs: ['产品介绍'],//,'产品流程'
        }
    }
    renderTab() {
        return this.state.tabs.map((item,idx) => {
            return <li key={idx} 
                        className={idx === this.state.activeTabIdx ? 'active' : ''}
                        onClick={() => this.tabClick(idx)}    
                    >
                        {item}
                    </li>
        })
    }
    tabClick(idx){
        this.setState({
            activeTabIdx: idx
        });
    }
    render() {
        return (
            <div className="content introduce">
                <div className="left">
                    <ul id="tab">
                        {this.renderTab()}
                    </ul>
                </div>
                <div className="right">
                    <div id="introduce" className={this.state.activeTabIdx === 0 ? 'active' : ''}>
                        <div className="cont">
                            <p>"智能快递柜"，是一台24小时社区便民服务终端，为收件人提供自助取快递、公共事业缴费等便民服务；</p>
                            <p>"智能快递柜"，一改传统的快递配送模式，通过智能投递，结合动态短信密码开箱，及时提醒收件人自助取件，提供便捷安全的快递代收发服务；</p>
                            <p>"智能快递柜"，为社区免费安装，并且向物业公司或业委会提供一定管理费用。只需要2平米的空间，即可为物业公司、业主、快递员提供符合智慧社区建设目标的高档服务。</p>
                        </div>
                        <div className="cont">
                            <p>智能快递柜，仅占用2平米左右的室内空间！</p>
                        </div>
                        <div className="cont">
                            <p>智能快递柜！业主、快递员纯自助服务，为物业节省人工、提升服务质量；更安全、更可靠！</p>
                        </div>
                    </div>
                    <div id="flow">
                    </div>
                </div>
            </div>
        )
    }
}